import { memo, PropsWithChildren, useState } from 'react';

import { GoogleAnalytics } from 'utils/GoogleAnalytics';

import { Header } from './Header';
import { Footer } from './Footer';
import { ContactForm } from './ContactForm';
import { CookieBanner } from './CookieBanner';
import { ContactModal } from './Header/ContactModal';

type LayoutProps = PropsWithChildren<{
  showContactForm?: boolean;
  scrollAction?: () => void;
}>;

const LayoutBase = ({ children, showContactForm = true, scrollAction }: LayoutProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <>
      <div className="layout">
        <h1 className="hidden">AI Live Sim</h1>
        <GoogleAnalytics />
        <Header />
        {children}
        {showContactForm && <ContactForm onClick={scrollAction ?? toggleModal} />}
        <Footer />
        <CookieBanner />
      </div>

      <ContactModal onClose={toggleModal} isOpen={isModalOpen} />
    </>
  );
};

export const Layout = memo(LayoutBase);
